module.exports = __webpack_public_path__ + "static/media/flag-es.d55b864e.svg";